import { SelectedFilters } from '@/components/FilterData/types';
import { api } from '@/services/api';
import { UUID } from '@/api/generatedApi';
import {
  normalizeSelectedFilters,
  normalizeSearchQuery,
  normalizePage,
  normalizePerPage,
} from '@/components/Search/utils';

export const CROSS_TENANT_ASSETS_VISUAL_SEARCH_QUERY_KEY = 'crossTenant.assetsVisualSearch';

export const queryKey = ({
  assetId,
  assetTenantId,
  searchTenantId,
  searchQuery,
  selectedFilters,
  sizeThreshold,
  page,
  perPage,
}: {
  assetId: UUID;
  assetTenantId: UUID;
  searchTenantId: UUID;
  searchQuery?: string;
  selectedFilters?: SelectedFilters;
  sizeThreshold?: number;
  page?: string | number;
  perPage?: string | number;
}) => [
  CROSS_TENANT_ASSETS_VISUAL_SEARCH_QUERY_KEY,
  {
    assetId,
    assetTenantId,
    searchTenantId,
    searchQuery: normalizeSearchQuery(searchQuery),
    selectedFilters: normalizeSelectedFilters(selectedFilters),
    sizeThreshold,
    page: normalizePage(page),
    perPage: normalizePerPage(perPage),
  },
];

export const queryFunction =
  ({
    assetId,
    assetTenantId,
    searchTenantId,
    searchQuery,
    selectedFilters,
    sizeThreshold,
    page,
    perPage,
  }: {
    assetId: UUID;
    assetTenantId: UUID;
    searchTenantId: UUID;
    searchQuery?: string;
    selectedFilters?: SelectedFilters;
    sizeThreshold?: number;
    page?: string | number;
    perPage?: string | number;
  }) =>
  () =>
    api.crossTenant.crossTenantVisualSearch({
      assetId,
      assetTenantId,
      searchTenantId,
      searchQuery: normalizeSearchQuery(searchQuery),
      filters: normalizeSelectedFilters(selectedFilters),
      sizeThreshold,
      page: normalizePage(page),
      perPage: normalizePerPage(perPage),
    });
